import moment from 'moment'

export default {
    methods: {
        formatDate(date, format) {
            if (!date) {
                return null
            }
            format = format || ' MMMM Do YYYY'
            return moment(date).format(format)
        },

        ago(date) {
            return moment(date).fromNow()
        }
    },

    computed: {
        minStartDate() {
            return moment().subtract(14, 'days').format('YYYY-MM-DD')
        }
    }
}